module.exports = __webpack_public_path__ + "media/images/optional_medal-8dd9576b.png";